export const PUBLIC_NAVBAR_ICONS = {
  logoIcon: 'home/navbar/Logo Icon.svg',
  logoText: 'home/navbar/Logo Text.svg',
  copyLink: 'home/navbar/Copy Link Icon.svg',
  menu: 'home/navbar/Menu Icon.svg',
} as const;
